import Contact from 'components/Pages/Contact/Contact';

export default Contact;
